import { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import TopAppBar from './components/TopAppBar';
import BottomNav from './components/BottomNav';
import MainTabs from './components/MainTabs';
import ProductTabs from './components/ProductTabs';
import { initializeApp } from "firebase/app";

import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";

const firebaseConfig = {

  apiKey: "AIzaSyDWEXM4E5TwKxNlDN_NrAsx-YqbRIAhR7c",

  authDomain: "syntheticdatapoc.firebaseapp.com",

  projectId: "syntheticdatapoc",

  storageBucket: "syntheticdatapoc.firebasestorage.app",

  messagingSenderId: "337075958259",

  appId: "1:337075958259:web:717973b2307d666db46286"

};

const app = initializeApp(firebaseConfig);
const provider = new GoogleAuthProvider();

function App() {
  const auth = getAuth();
  const [user, setUser] = useState(null);

  const loginUser = () => {
    signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      // The signed-in user info.
      const userx = result.user;
      // console.log(userx);
      setUser(userx);
      // IdP data available using getAdditionalUserInfo(result)
      // ...
    }).catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
    });
  }

  const logoutUser = () => {
    const auth = getAuth();
    signOut(auth).then(() => {
      setUser(null);
    }).catch((error) => {
      // An error happened.
    });
  }

  return (
    <div className="App">
      <header className="App-header">
        <TopAppBar user={user} loginUser={loginUser} logoutUser={logoutUser} />
        {!user && (
          <>
            <br />
            <br />
            <br />
            <MainTabs />
            <BottomNav />
          </>
        )}
        {user && (
          <>
            <br />
            <br />
            <br />
            <ProductTabs />
            <BottomNav />
          </>
        )}
      </header>
    </div>
  );
}

export default App;
